import { FC } from 'react'

import styled from 'styled-components'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Loader } from '@mantine/core'

import { Pagination } from 'src/Helpers/types.ts'
import { TableLoading } from 'src/Components/TableLoading'
import { OfferItem } from 'src/Components/OfferItem'
import { Offer } from 'src/Redux/api/offersApi.ts'
import { NoDataMessage } from 'src/Components/NoDataMessage'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  flex: 1;
  min-height: 0;
`

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 16px;
`

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const LoaderWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`

type ArchiveTableProps = {
  isLoading: boolean
  offers?: Offer[]
  onViewOffer: (id: number) => void
  onCreateContract: (offerNumber: number) => void
  onCloneOffer: (id: number) => void
  onDeleteOffer: (id: number) => void
} & Pagination

export const OffersTable: FC<ArchiveTableProps> = ({
  isLoading,
  offers,
  onLoadMore,
  hasNextPage,
  onViewOffer,
  onCreateContract,
  onCloneOffer,
  onDeleteOffer,
}) => {
  if (isLoading) {
    return (
      <ListWrapper>
        <TableLoading />
      </ListWrapper>
    )
  }

  if (offers?.length === 0) {
    return (
      <ListWrapper>
        <NoDataMessage />
      </ListWrapper>
    )
  }

  return (
    <Container>
      <ListWrapper id='scrollableDiv'>
        <InfiniteScroll
          scrollableTarget={'scrollableDiv'}
          dataLength={offers?.length || 0}
          next={onLoadMore}
          hasMore={Boolean(hasNextPage)}
          loader={
            <LoaderWrapper>
              <Loader color='blue' />
            </LoaderWrapper>
          }
        >
          <ItemsContainer>
            {offers?.map((offer) => (
              <OfferItem
                key={offer.id}
                offer={offer}
                onViewOffer={onViewOffer}
                onCreateContract={onCreateContract}
                onCloneOffer={onCloneOffer}
                onDeleteOffer={onDeleteOffer}
              />
            ))}
          </ItemsContainer>
        </InfiniteScroll>
      </ListWrapper>
    </Container>
  )
}
